import {
  CREATE_COMMENT,
    GET_COMMENT,
    SET_ALL_COMMENT,
    SET_ALL_COMMENT_LESSON,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_COMMENT:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_COMMENT_LESSON:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_COMMENT:
      return {
        ...state,
        getData: action.payload,
      };
    case CREATE_COMMENT:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default commentReducer;
